import React from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'unistore/full/react';
import actions from './actions';
import { DeferredLoadingIcon } from './DeferredLoadingIcon';
import './PlaylistHeaderRadioTags.scss';
import { Scroller } from './Scroller';

export default connect(({ playlistsById }, { playlistId }) => {
  const { isOwnedBySpotify, isOwnedByCurrentUser, tags } =
    playlistsById[playlistId] || {};

  return {
    isOwnedBySpotify,
    isOwnedByCurrentUser,
    tags,
  };
}, actions)(React.memo(PlaylistHeaderRadioTags));

function PlaylistHeaderRadioTags(props) {
  const history = useHistory();
  const { playlistId, isOwnedBySpotify, isOwnedByCurrentUser, tags } = props;

  return isOwnedBySpotify ? null : (
    <div className="PlaylistHeaderRadioTags__tag-radio">
      <div className="PlaylistHeaderRadioTags__tag-radio-title">
        {isOwnedByCurrentUser
          ? 'Based on your playlist'
          : 'Based on this playlist'}
      </div>

      <Scroller
        scrollId={`${playlistId}-tags`}
        className="PlaylistHeaderRadioTags__tag-radio-tags-wrapper"
        direction="horizontal"
      >
        <div className="PlaylistHeaderRadioTags__tag-radio-tags">
          {!tags ? (
            <div className="PlaylistHeaderRadioTags__loading-icon-wrapper">
              <DeferredLoadingIcon />
            </div>
          ) : (
            tags?.map((name) => (
              <div
                className="PlaylistHeaderRadioTags__tag-radio-tag"
                onClick={() =>
                  history.push(
                    `/station/playlist/${playlistId}/${encodeURIComponent(
                      name
                    )}`
                  )
                }
              >
                {name}

                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginLeft: '4px' }}
                >
                  <g opacity="0.7">
                    <path
                      d="M4.0111 8.22621C4.0841 7.29421 4.5161 6.44621 5.2271 5.83921C5.4061 5.68621 5.6001 5.55121 5.8051 5.43821L5.3201 4.56321C5.0581 4.70821 4.8081 4.88221 4.5781 5.07821C3.6641 5.85921 3.1091 6.94921 3.0141 8.14721C2.9201 9.34521 3.2981 10.5092 4.0781 11.4232C4.4261 11.8292 4.8451 12.1702 5.3231 12.4342L5.8061 11.5592C5.4331 11.3522 5.1071 11.0882 4.8381 10.7732C4.2321 10.0622 3.9381 9.15721 4.0111 8.22621ZM13.2031 3.62921C12.7521 3.10121 12.2221 2.63421 11.6251 2.24121L11.0741 3.07621C11.5921 3.41821 12.0521 3.82221 12.4421 4.27921C13.5701 5.59921 14.1161 7.28021 13.9791 9.01021C13.8431 10.7412 13.0411 12.3152 11.7201 13.4432C11.5131 13.6212 11.2951 13.7772 11.0731 13.9242L11.6231 14.7592C11.8801 14.5902 12.1301 14.4082 12.3701 14.2042C13.8931 12.9032 14.8191 11.0862 14.9761 9.08921C15.1341 7.09121 14.5041 5.15221 13.2031 3.62921ZM2.5581 12.7222C0.230096 9.99621 0.554096 5.88521 3.2801 3.55821C3.4871 3.38021 3.7051 3.22421 3.9271 3.07821L3.3761 2.24321C3.1191 2.41221 2.8691 2.59321 2.6301 2.79721C1.1061 4.09821 0.181096 5.91521 0.0240959 7.91221C-0.132904 9.90921 0.497096 11.8482 1.7971 13.3722C2.2481 13.9002 2.7791 14.3672 3.3751 14.7602L3.9251 13.9252C3.4081 13.5832 2.9481 13.1782 2.5581 12.7222ZM10.9221 5.57721C10.5741 5.17121 10.1551 4.83021 9.6771 4.56621L9.1941 5.44121C9.5671 5.64821 9.8931 5.91221 10.1621 6.22721C10.7701 6.93821 11.0631 7.84321 10.9901 8.77521C10.9171 9.70721 10.4851 10.5552 9.7731 11.1622C9.5951 11.3142 9.4011 11.4502 9.1961 11.5632L9.6811 12.4382C9.9441 12.2922 10.1941 12.1182 10.4231 11.9232C11.3371 11.1422 11.8921 10.0522 11.9871 8.85421C12.0801 7.65521 11.7021 6.49121 10.9221 5.57721ZM7.5001 7.00021C6.6721 7.00021 6.0001 7.67121 6.0001 8.50021C6.0001 9.32921 6.6721 10.0002 7.5001 10.0002C8.3291 10.0002 9.0001 9.32921 9.0001 8.50021C9.0001 7.67121 8.3291 7.00021 7.5001 7.00021Z"
                      fill="white"
                    />
                  </g>
                </svg>
              </div>
            ))
          )}
        </div>
      </Scroller>
    </div>
  );
}
